import { useState, useEffect } from "react";
import '../stylesheets/work.css';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faExternalLinkAlt, faCode, faPlay, faXmark } from '@fortawesome/free-solid-svg-icons';

/* Fallback hardcoded projects (used when /projects.php is unavailable) */
const projects = [
  {
    title: 'Renewable Energy Systems',
    description: 'Renewable energy systems is a UPS and power solutions website, the owner can show all of his solutions and offers. the website is made by HTML, CSS, Javascript, Angular, PHP and MYSQL.',
    tech: ['HTML', 'CSS', 'Javascript', 'Angular', 'PHP', 'MYSQL'],
    link: 'https://res.abuelkhair.site/',
    code: 'https://github.com/mostafa-abuelkhair/res-eg.git',
    color: '#f7931e',
    bg: 'projects_media/res.png',
    video: 'projects_media/res.mp4',
  },
  {
    title: 'Grid Portfolio',
    description: 'Portfolio in a grid theme, the owner can show all of his experience and share his contacts. the website is made by HTML, CSS, Javascript, Angular, PHP and MYSQL.',
    tech: ['HTML', 'CSS', 'Javascript', 'Angular', 'PHP', 'MYSQL'],
    link: 'https://abdelkhalek.abuelkhair.site/',
    code: 'https://github.com/mostafa-abuelkhair/portfolio-grid.git',
    color: '#6c63ff',
    bg: 'projects_media/portfolio_grid.png',
    video: 'projects_media/portfolio_grid.mp4',
  },
  {
    title: 'Morning Online Store',
    description: 'Morning is an online store where the owner can show all of his products and offers. the website has an admin panel that has dashboard and the control of products and orders and users and admins. this project is made by teamwork between me and two others, the website is made by HTML, CSS, javascript, NodeJs and Mongo DB.',
    tech: ['HTML', 'CSS', 'Javascript', 'NodeJs', 'MongoDB'],
    link: 'https://morning-9mq7.onrender.com',
    code: 'https://github.com/mostafa-abuelkhair/Morning-Online-Store.git',
    color: '#fb503b',
    bg: 'projects_media/morning.png',
    video: 'projects_media/morning.mp4',
  },
  {
    title: 'Crew Saudi Platform',
    description: 'Crew is a Saudi platform that helps hospitality, F&B, & aviation businesses hire faster and easier, the website was made by HTML, CSS, Javascript, Angular, Laravel and MYSQL.',
    tech: ['HTML', 'CSS', 'Javascript', 'Angular', 'Laravel', 'MYSQL'],
    link: '',
    code: '',
    color: '#00d4aa',
    bg: 'projects_media/crew.png',
    video: 'projects_media/crew.mp4',
  },
  {
    title: 'MultiShop Online Store',
    description: 'Multi shop is a Online shop website where the owner can show all of his products and offers, which the users can add to cart and purchase, this project is made by teamwork between me and two others. the website is made by HTML, CSS, javascript, NodeJs and Mongo DB.',
    tech: ['HTML', 'CSS', 'Javascript', 'NodeJs', 'MongoDB'],
    link: 'https://multishop.onrender.com',
    code: 'https://github.com/mostafa-abuelkhair/MultiShop-Online-Shop.git',
    color: '#61dafb',
    bg: 'projects_media/multishop.png',
    video: 'projects_media/multishop.mp4',
  },
  {
    title: 'Zero Percent Marketing',
    description: 'Landing website for a marketing business, highly focused and visually compelling web page designed to capture leads, promote services.',
    tech: ['HTML', 'CSS', 'Javascript', 'Marketing'],
    link: 'https://0percent.co/',
    code: '',
    color: '#f0f4ff',
    bg: 'projects_media/zero_percent.png',
    video: 'projects_media/zero_percent.webm',
  },
  {
    title: 'Service Center System',
    description: 'Service center system where the users can add information about the device to be serviced and comments and notes durring the maintinance, and records the repaired and stored devices. the wbsite is made by HTML, CSS, javascript, WordPress, Angularjs, PHP and MYSQL.',
    tech: ['HTML', 'CSS', 'Javascript', 'WordPress', 'Angularjs', 'PHP', 'MYSQL'],
    link: 'https://abuelkhair.online/service',
    code: '',
    color: '#9b59b6',
    bg: 'projects_media/service.png',
    video: 'projects_media/service.mp4',
  },
  {
    title: 'Cam Tech CCTV',
    description: 'Cam Tech is a CCTV shop website where the owner can show all of his systems and offers,  the website has an admin page so the admin can add and edits products. the website is made by HTML, CSS, javascript, Angularjs, PHP and MYSQL.',
    tech: ['HTML', 'CSS', 'Javascript', 'Angularjs', 'PHP', 'MYSQL'],
    link: 'https://abuelkhair.online/camtech',
    code: 'https://github.com/mostafa-abuelkhair/camtech.git',
    color: '#2496ed',
    bg: 'projects_media/camTech.png',
    video: 'projects_media/camTech.mp4',
  },
];

/* Video component — key on src so it reloads when project changes */
function Video({ src }) {
  if (!src) return null;
  return (
    <video key={src} className="modal-video" controls muted autoPlay preload="metadata">
      <source src={'/' + src} type="video/mp4" />
      <source src={'/' + src} type="video/webm" />
      Your browser does not support the video tag.
    </video>
  );
}

function Work() {
  const [displayedProjects, setDisplayedProjects] = useState(projects);
  const [selected, setSelected] = useState(null); // project currently shown in modal
  const [modalOpen, setModalOpen] = useState(false);

  /* ── Fetch from API, fall back to hardcoded ── */
  useEffect(() => {
    const controller = new AbortController();
    const timeoutId = setTimeout(() => controller.abort(), 5000);

    fetch('/projects.php', { method: 'GET', signal: controller.signal })
      .then((res) => {
        if (!res.ok) throw new Error('API error');
        return res.json();
      })
      .then((data) => {
        console.log('d');
        console.log(data);
        clearTimeout(timeoutId);
        if (Array.isArray(data) && data.length > 0) {
          const normalized = data.map((d) => ({
            title: d.title || d.name || 'Project',
            description: d.description || '',
            tech: Array.isArray(d.tech) ? d.tech : (typeof d.tech === 'string' ? d.tech.split(',').map(t => t.trim()) : []),
            link: d.link || '',
            code: d.code || '',
            color: d.color || '#6c63ff',
            bg: d.bg || '',
            video: d.video || '',
          }));
          setDisplayedProjects(normalized);
        }
      })
      .catch((error) => {
        clearTimeout(timeoutId);
        console.error(error);
      });

    return () => { clearTimeout(timeoutId); controller.abort(); };
  }, []);

  /* ── Modal helpers ── */
  const openModal = (proj) => { setSelected(proj); setModalOpen(true); };
  const closeModal = () => { setModalOpen(false); setSelected(null); };

  /* Close on backdrop click */
  const onBackdrop = (e) => { if (e.target === e.currentTarget) closeModal(); };

  return (
    <section className="work-section reveal" id="work">

      <h2 className="section-title">
        <span className="section-number">04.</span> Things I've Built
      </h2>

      {/* ── Project Cards Grid ── */}
      <div className="projects-grid">
        {displayedProjects.map((proj, i) => (
          <div
            key={i}
            className="project-card reveal"
            style={{ '--card-accent': proj.color }}
            onClick={() => openModal(proj)}
          >
            {/* Thumbnail if available */}
            {proj.bg && (
              <div
                className="project-thumbnail"
                style={{ backgroundImage: `url(${proj.bg})` }}
              >
                {proj.video && (
                  <div className="play-overlay">
                    <FontAwesomeIcon icon={faPlay} />
                  </div>
                )}
              </div>
            )}

            <div className="project-body">
              <div className="project-top">
                <span className="project-number">0{i + 1}.</span>
                <div className="project-links" onClick={(e) => e.stopPropagation()}>
                  {proj.code && (
                    <a href={proj.code} target="_blank" rel="noopener noreferrer" title="View Code">
                      <FontAwesomeIcon icon={faCode} />
                    </a>
                  )}
                  {proj.link && (
                    <a href={proj.link} target="_blank" rel="noopener noreferrer" title="Live Demo">
                      <FontAwesomeIcon icon={faExternalLinkAlt} />
                    </a>
                  )}
                </div>
              </div>

              <h3 className="project-title">{proj.title}</h3>
              <p className="project-desc">{proj.description}</p>

              <div className="project-tech">
                {proj.tech.map((t, j) => (
                  <span key={j} className="tech-tag">{t}</span>
                ))}
              </div>
            </div>
          </div>
        ))}
      </div>

      {/* ── Video Modal ── */}
      {modalOpen && selected && (
        <div className="work-modal-backdrop" onClick={onBackdrop}>
          <div className="work-modal">

            <button className="modal-close-btn" onClick={closeModal}>
              <FontAwesomeIcon icon={faXmark} />
            </button>

            <div className="modal-inner">
              {/* Video panel */}
              {selected.video ? (
                <div className="modal-video-wrap">
                  <Video src={selected.video} />
                </div>
              ) : (
                selected.bg && (
                  <div
                    className="modal-video-wrap modal-img-fallback"
                    style={{ backgroundImage: `url(${selected.bg})` }}
                  />
                )
              )}

              {/* Info panel */}
              <div className="modal-info">
                <h3 className="modal-title" style={{ color: selected.color }}>
                  {selected.title}
                </h3>
                <p className="modal-desc">{selected.description}</p>

                <div className="modal-tech">
                  {selected.tech.map((t, j) => (
                    <span key={j} className="tech-tag">{t}</span>
                  ))}
                </div>

                <div className="modal-actions">
                  {selected.link && (
                    <a href={selected.link} target="_blank" rel="noopener noreferrer" className="modal-btn modal-btn-primary">
                      <FontAwesomeIcon icon={faExternalLinkAlt} /> Live Demo
                    </a>
                  )}
                  {selected.code && (
                    <a href={selected.code} target="_blank" rel="noopener noreferrer" className="modal-btn modal-btn-ghost">
                      <FontAwesomeIcon icon={faCode} /> View Code
                    </a>
                  )}
                </div>
              </div>
            </div>

          </div>
        </div>
      )}

    </section>
  );
}

export default Work;
